module.exports = __webpack_public_path__ + "img/2Reihe_4.9283fe66.jpg";